import { useSelector as useReduxSelector, type TypedUseSelectorHook } from 'react-redux';
import { RootState } from './store';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
